import { render } from "./MainNav.vue?vue&type=template&id=75f33eb5"
const script = {}

import exportComponent from "/home/dbomfim/projects/meucolegio/fetecc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__